import React, { useEffect, useState } from "react";
import {
  AlignJustify,
  ArrowDown,
  Bell,
  ChevronDown,
  Gift,
  LogOut,
  User,
  UserCheck,
  UserPlus,
  Users,
  X,
} from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import image2 from "../assets/profile/female-icon.png";
import { stack as Menu } from "react-burger-menu";
import femaleIcon from "../assets/profile/female-icon.png";
import maleIcon from "../assets/profile/user.jpeg";
import defaultPic from "../assets/profile/defaultuser1.png";
import { useSocket } from "../Helper/Socket";
import { logout } from "../Store/Actions/LoginAction";

import PostApiCall from "../Api/Api";
import CommonModal from "./CommonModal";
import ReferralComponent from "./ReferralComponent";
import WebinarTicker from "./WebinarTicker";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FaEnvelope, FaLink, FaUserPlus, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import GetApiCall from "../Api/GetApi";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import { SomethingWrong } from "../Helper/ErrorMessages";

const Navbar = () => {
  // UseState
  const [NotificationData, setNotificationData] = useState([]);
  const [RefferalData, setRefferalData] = useState({});
  const [UnReadNotificationCount, setUnReadNotificationCount] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const user = useSelector((state) => state?.login);
  const profile = useSelector((state) => state?.profile);

  const location = useLocation();
  const history = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [refferalModal, setRefferalModal] = useState(false);
  const dispatch = useDispatch();
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const navigation = [
    {
      label: "Home",
      route: "/",
      role: [
        "Staff",
        "user",
        "Seeker",
        "Auditor",
        "Recruiter",
        user?.fld_isadmin === 1 && "Staff",
      ],
      isAdmin: 1,
    },

    {
      label: "Jobs",
      route: "/jobs-opening-list",
      role: ["user", "Seeker", "Auditor"],
    },
    // {
    //   label: "About Us",
    //   route: "/About-us",
    //   role: [
    //     "Staff",
    //     "user",
    //     "Seeker",
    //     "Auditor",
    //     "Recruiter",
    //     user?.fld_isadmin === 1 && "Staff",
    //   ],
    //   isAdmin: 1,
    // },
    {
      label: "Refer & Earn",
      // route: "/#",
      route: "/refer-earn",
      role: ["user", "Seeker", "Auditor"],
    },
    {
      label: "Blogs",
      route: "/blogs",
      role: [
        "Staff",
        "user",
        "Seeker",
        "Auditor",
        "Recruiter",
        user?.fld_isadmin === 1 && "Staff",
      ],
    },
    // {
    //   label: "Audit Opening",
    //   route: "/audits-opening-list",
    //   role: ["Auditor"],
    // },
    {
      label: "Auditor",
      route: "/auditor-list",
      role: ["Staff", user?.fld_isadmin === 1 && "Staff"],
      // subRoute: [
      //   {
      //     label: "Add Auditor",
      //     route: "/add-auditor",
      //   },
      //   {
      //     label: "Auditor List",
      //     route: "/auditor-list",
      //   },
      // ],
    },

    // {
    //   label: "Publish Audit",
    //   route: "/publish-audit",
    //   role: ["Staff", user?.fld_isadmin === 1 && "Staff", "Recruiter"],
    //   isAdmin: 1,
    // },
    {
      label: "Publish Job",
      route: "/publish-job",
      role: ["Staff", user?.fld_isadmin === 1 && "Staff", "Recruiter"],
    },
    // user?.fld_name && {
    //   label: "Notification",
    //   route: "#",
    //   role: [
    //     "Staff",
    //     "user",
    //     "Seeker",
    //     "Auditor",
    //     "Recruiter",
    //     user?.fld_isadmin === 1 && "Staff",
    //   ],
    // },

    {
      label: user?.fld_name ? "My Account" : "Login",
      route: user?.fld_name ? "/account" : "/login",
      role: ["user", "Seeker", "Auditor"],
      subRoute: [
        {
          label: "My Profile",
          route: "/account",
          role: ["Seeker", "Auditor"],
        },
        {
          label: "Sign out",

          role: ["Seeker", "Auditor"],
        },
      ],
      isAdmin: 1,
    },
    {
      label: user?.fld_name ? "My Account" : "Corporate Login",
      route: user?.fld_name ? "/account" : "/admin-login",
      role: ["Staff", "user", user?.fld_isadmin === 1 && "Staff", "Recruiter"],
      subRoute: [
        {
          label: "My Profile",
          route: "/account",
          role: [user?.fld_isadmin === 1 && "Staff", "Recruiter"],
        },
        {
          label: "Sign out",

          role: [user?.fld_isadmin === 1 && "Staff", "Recruiter"],
        },
      ],
      isAdmin: 1,
    },
  ];

  const mobileNavigation = [
    {
      label: "Home",
      route: "/",
      role: [
        "Staff",
        "user",
        "Seeker",
        "Auditor",
        user?.fld_isadmin === 1 && "Staff",
        "Recruiter",
      ],
    },
    // {
    //   label: "About Us",
    //   route: "/About-us",
    //   role: [
    //     "Staff",
    //     "user",
    //     "Seeker",
    //     "Auditor",
    //     user?.fld_isadmin === 1 && "Staff",
    //     "Recruiter",
    //   ],
    // },
    {
      label: "Jobs",
      route: "/jobs-opening-list",
      role: ["user", "Seeker", "Auditor"],
    },
    {
      label: "Refer & Earn",
      route: "/refer-earn",
      role: ["user", "Seeker", "Auditor"],
    },
    // {
    //   label: "Audit Opening",
    //   route: "/audits-opening-list",
    //   role: ["Auditor", "Recruiter"],
    // },

    {
      label: "Auditor",
      route: "/auditor-list",
      role: ["Staff", user?.fld_isadmin === 1 && "Staff"],
      // subCategory: [
      //   {
      //     label: "Add Auditor",
      //     route: "/add-auditor",
      //     role: ["admin"],
      //   },
      //   {
      //     label: "Auditor List",
      //     route: "/auditor-list",
      //     role: ["admin"],
      //   },
      // ],
    },

    // {
    //   label: "Publish Audit",
    //   route: "/publish-audit",
    //   role: ["Staff", user?.fld_isadmin === 1 && "Staff"],
    //   isAdmin: 1,
    // },
    {
      label: "Publish Job",
      route: "/publish-job",
      role: ["Staff", user?.fld_isadmin === 1 && "Staff"],
    },

    {
      label: user?.fld_name ? "My Account" : "Login",
      route: user?.fld_name ? "/account" : "/login",
      role: ["user", "Seeker", "Auditor"],

      isAdmin: 1,
    },
    {
      label: user?.fld_name ? "My Account" : "Corporate Login",
      route: user?.fld_name ? "/account" : "/admin-login",
      role: ["Staff", "user", "Recruiter", user?.fld_isadmin === 1 && "Staff"],

      isAdmin: 1,
    },
    {
      label: "Sign out",

      role: [
        user?.fld_isadmin === 1 && "Staff",
        "Seeker",
        "Auditor",
        "Recruiter",
      ],
    },
  ];

  const isSubRouteActive = (subRoute) => {
    return subRoute.some((sub) => window.location.pathname === sub.route);
  };

  const socket = useSocket();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token && socket) {
      socket.emit("authenticatedEvent", { token });
      socket.emit("FetchNotificationData");
      socket.on("GetNotificationData", (data) => {
        setNotificationData(data.slice(0, 5));
        let len = data.filter((ele) => ele.fld_status === 1);

        setUnReadNotificationCount(len.length);
      });
    }
    socket.on("PushNotification", (msg) => {
      socket.emit("FetchNotificationData");
    });
  }, [window.location.href]);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const UpdateNotificationStatus = async () => {
    const payload = {
      userid: user.fld_id,
      usertype: user.fld_usertype === "Staff" ? "Admin" : user.fld_usertype,
    };
    const dd = await PostApiCall.postRequest(
      payload,
      "UpdateNotificationStatus"
    );
  };

  const getRefferalCode = async () => {
    try {
      // Show loading indicator
      // Notiflix.Loading.init({ svgColor: "#c16d18" });
      Notiflix.Loading.standard();

      // Make the API request
      const resultdes = await GetApiCall.getRequest("GetJobUserRefer");

      // Try parsing the response as JSON
      const obj = await resultdes.json();

      if (resultdes.ok) {
        // If the response is OK, set referral data
        setRefferalData(obj?.data);
      } else {
        // Handle API errors (e.g., 4xx or 5xx status codes)

        toast.error(obj?.message || "Failed to fetch referral data.");
      }
    } catch (error) {
      toast.error(SomethingWrong);
    } finally {
      // Always remove the loading indicator
      Notiflix.Loading.remove();
    }
  };

  // const toggle = () => setPopoverOpen(!popoverOpen);
  return (
    <div className="navbar-wrapper">
      {/* <WebinarTicker className="webinar-ticker"/> */}
      <div className="navbar navbar-expand-lg scrolling-navbar shadow-sm bg-white px-0">
      <div className="container-fluid mx-md-5">
        <div className="theme-header clearfix">
          <div className="navbar-header">
            <Link to="/" className="navbar-brand">
              <div style={{display:'flex',flexDirection:'column'}}>
                <img
                  src="/assets/img/betel-jobs-logo.png"
                  width={"110px"}
                  alt=""
                />
                <span style={{fontSize:'11px',fontFamily:'serif'}} className="ml-4"> by TRPW Partners</span>
              </div>
            </Link>
          </div>
          <div></div>
          <div className="collapse navbar-collapse" id="main-navbar">
            <ul className="navbar-nav mr-auto w-100 justify-content-end mt-1">
              {navigation.map((item, index) => {
                if (
                  item?.role?.includes(
                    user === null ||
                      user === undefined ||
                      user.isloggedIn === false
                      ? "user"
                      : user?.fld_usertype ||
                          (user?.fld_isadmin === 1 && "Staff")
                  )
                ) {
                  const isActive =
                    location.pathname === item.route ||
                    (item.subRoute && isSubRouteActive(item.subRoute));
                  // Determine specific styles based on route cases
                  const isLoginActive = location.pathname === "/login";
                  const isAdminLoginActive =
                    location.pathname === "/admin-login";
                  return (
                    <li
                      className={`dropdown  ${
                        (item.route === "/login" ||
                          item.route === "/admin-login") &&
                        "button"
                      }  ${isActive ? "nav-item active" : "nav-item"}`}
                      key={index++}
                    >
                      <div
                        // className={`${
                        //   (item.route === "/login" || item.route === "/admin-login") && "button btn btn-common"
                        // }`}
                        className={`${
                          (isLoginActive && item.route === "/login") ||
                          (isAdminLoginActive && item.route === "/admin-login")
                            ? "navbtns mt-3"
                            : item.route === "/login" && !isAdminLoginActive
                            ? "navbtns mt-3"
                            : ""
                        }`}
                      >
                        <Link
                          // className={` ${
                          //   !(item.route === "/login" || item.route === "/admin-login")
                          //     ? "nav-link dropdown-toggle"
                          //     : "btn-color"
                          // } ${isActive && "active"}`}
                          className={` ${
                            item.route === "/login" && !isAdminLoginActive
                              ? "btn-color"
                              : isLoginActive && item.route === "/login"
                              ? "btn-color active"
                              : isAdminLoginActive &&
                                item.route === "/admin-login"
                              ? "btn-color active"
                              : "nav-link dropdown-toggle"
                          } ${isActive && "active"}`}
                          to={item.route}
                        >
                          {item.label === "My Account" ? (
                            <div className="d-flex align-items-center">
                              <div
                                className="rounded-circle shadow-md mr-2 border"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                }}
                              >
                                <img
                                  width={"100%"}
                                
                                  className="p-1 rounded-circle"
                                  src={
                                    process.env.REACT_APP_FILE_PATH_URL +
                                    profile?.user?.fld_photo
                                  }
                                  onError={(e) => (e.target.src = maleIcon)}
                                />
                              </div>
                              <p
                                className="d-flex font-size-3"
                                style={{ flexDirection: "column" }}
                              >
                                <span
                                  className="font-weight-bold text-capitalize"
                                  style={{ textAlign: "start" }}
                                >
                                  {user.fld_name}
                                </span>
                              </p>
                            </div>
                          ) : (
                            <span className="font-size-4">{item.label}</span>
                          )}
                        </Link>
                      </div>
                      {/* profile dropdown */}

                      {item?.subRoute?.length > 0 &&
                        item.label === "My Account" && (
                          <div
                            className="dropdown-menu "
                            aria-labelledby="navbarDropdown"
                          >
                            {item.subRoute.map((dd, index) => {
                              return (
                                <>
                                  {dd.label === "Sign out" ? (
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <span
                                        style={{
                                          background: "#ccc",
                                          width: "30px",
                                          height: "30px",
                                          textAlign: "center",
                                        }}
                                        className="rounded-circle"
                                      >
                                        <LogOut size={16} />
                                      </span>
                                      <div
                                        key={index++}
                                        className={`nav-link   ${
                                          window.location.pathname === dd.route
                                            ? "baseTextColor"
                                            : "text-dark"
                                        }`}
                                        onClick={() => dispatch(logout())}
                                      >
                                        {dd.label}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="d-flex align-items-center pointer">
                                      <span
                                        style={{
                                          background: "#ccc",
                                          width: "30px",
                                          height: "30px",
                                          textAlign: "center",
                                        }}
                                        className="rounded-circle"
                                      >
                                        <User size={16} />
                                      </span>
                                      <Link
                                        key={index++}
                                        className={`text-gray nav-link  ${
                                          window.location.pathname === dd.route
                                            ? "baseTextColor"
                                            : "text-dark"
                                        }`}
                                        to={dd.route}
                                      >
                                        {dd.label}
                                      </Link>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        )}

                      {/* Notification dropdown */}

                      {item?.subRoute?.length > 0 &&
                        item.label === "Notification" && (
                          <div
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown"
                            style={{ width: "250px" }}
                          >
                            {item.subRoute.map((dd, index) => {
                              if (item.label === "Notification") {
                                if (dd.label === "View more") {
                                  return (
                                    <Link
                                      key={index++}
                                      className={`nav-link m-0 p-0`}
                                      to={dd.route}
                                      // key={`${index}-view-more`}
                                    >
                                      <div className="text-right">
                                        <span className="">View more..</span>
                                      </div>
                                    </Link>
                                  );
                                }

                                return (
                                  <>
                                    <div
                                      className="avatar d-flex align-items-center mb-1"
                                      key={`${index}-${dd.label}`}
                                    >
                                      <div className="mr-2">
                                        <img
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                          }}
                                          src={image2}
                                          alt="User Image"
                                          onError={(e) =>
                                            (e.target.src = maleIcon)
                                          }
                                        />
                                      </div>
                                      <div className="text-left text-truncate">
                                        <span
                                          className="text-dark"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {dd?.label}
                                        </span>
                                      </div>
                                    </div>
                                    <hr className="mx-1" />
                                  </>
                                );
                              }
                            })}
                          </div>
                        )}
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="mobile-navbar p-2 w-100 text-dark">
        <div className="d-flex justify-content-between align-items-center">
          <Link to="/" className="navbar-brand">
          <div style={{display:'flex',flexDirection:'column'}}>
                <img
                  src="/assets/img/betel-jobs-logo.png"
                  width={"110px"}
                  alt=""
                />
                <span style={{fontSize:'11px',fontFamily:'serif'}} className="ml-4"> by TRPW Partners</span>
              </div>
            {/* <img className="w-50" src="/assets/img/logo3.png" alt="" /> */}
          </Link>
          <div className="d-flex justify-content-between">
            {/* <span >

            {user?.fld_name && (
              <Link to="/notification" className="mr-2">
                <Bell
                  size={17}
                  style={{
                    marginRight: "-2px",
                    cursor: "pointer",
                    color: "green",
                  }}
                />
                <span className="bg-danger font-size-2 text-light rounded-circle p-1 sub">
                  {UnReadNotificationCount}
                </span>
              </Link>
            )}
            </span> */}

            <AlignJustify
              style={{ cursor: "pointer" }}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            />
          </div>
        </div>
        <Menu
          isOpen={isMenuOpen}
          customBurgerIcon={false} // Disable default burger icon
          className="bg-white p-3"
          width={"75%"}
          styles={{ top: "0", left: "0" }}
        >
          {/* Your existing mobile navigation content goes here */}
          <div className=" py-2 cursor-pointer shadow-sm d-flex justify-content-between align-items-center">
            <Link to="/" className="navbar-brand">
              {/* <img src="/assets/img/logo3.png" alt="" width={"100px"} /> */}
              <div style={{display:'flex',flexDirection:'column'}}>
                <img
                  src="/assets/img/betel-jobs-logo.png"
                  width={"100px"}
                  alt=""
                />
                <span style={{fontSize:'11px',fontFamily:'serif'}} className="ml-4"> by TRPW Partners</span>
              </div>
            </Link>
            <X
              size={27}
              className="text-white basebgColor"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            />
          </div>

          {mobileNavigation.map((item, index) => {
            if (
              item?.role?.includes(
                user === null || user === undefined || user.isloggedIn === false
                  ? "user"
                  : user?.fld_usertype || (user?.fld_isadmin === 1 && "Staff")
              )
            ) {
              // if (item.label === "Auditor") {
              //   return (
              //     <>
              //       <div
              //         onClick={toggle}
              //         className="menu-items d-flex justify-content-between"
              //         key={index}
              //       >
              //         <span> {item.label}</span>
              //         <span>
              //           {" "}
              //           <ChevronDown size={16} />
              //         </span>{" "}
              //         {/* Add your arrow icon here */}
              //       </div>
              //       {dropdownOpen && (
              //         <div style={{ display: "flex", flexDirection: "column" }}>
              //           {item?.subCategory?.map((sub, indexsub) => {
              //             return (
              //               <Link
              //                 to={sub.route}
              //                 onClick={closeMenu}
              //                 className="menu-items ml-3 font-size-4"
              //                 key={indexsub}
              //               >
              //                 <li>{sub?.label}</li>
              //               </Link>
              //             );
              //           })}
              //         </div>
              //       )}
              //     </>
              //   );
              // } else

              // if (item.label === "Refer & Earn") {
              //   return (
              //     <div
              //       style={{ cursor: "pointer" }}
              //        className="menu-items"
              //       onClick={() => {
              //         if (user) {
              //           setIsMenuOpen(false);
              //           setRefferalModal(true);
              //           getRefferalCode();
              //         } else {
              //           // window.location.href = '/login';
              //           setIsMenuOpen(false);
              //           history("/login");
              //         }
              //       }}
              //     >
              //       <Gift size={14} /> <span>{item.label}</span>
              //     </div>
              //   );
              // }
              if (item.label === "Sign out") {
                return (
                  <div
                    onClick={() => dispatch(logout())}
                    className="menu-items"
                    key={index}
                  >
                    {item.label}
                  </div>
                );
              } else {
                return (
                  <Link
                    to={item?.route}
                    onClick={closeMenu}
                    className="menu-items"
                    key={index}
                  >
                    {item?.label}
                  </Link>
                );
              }
            } else {
              return null;
            }
          })}
        </Menu>
      </div>
      {refferalModal === true && (
        <ReferralComponent
          modal={refferalModal}
          setModal={setRefferalModal}
          user={user}
          RefferalData={RefferalData}
        />
      )}
      </div>
    </div>
  );
};

export default Navbar;
